// GeneralStatistics.js
import React, { Component } from "react";
import { connect } from "react-redux";
import { getIntervalReports } from "../../actions/ReportsActions";
import { Table } from "semantic-ui-react";
import LoadingBar from "../utils/loadingBar";
import NotFound from "../utils/notFound";
import { digitToComma } from "../utils/numberUtils";
import {
  getTodayGregorian,
  toGregorian,
  getTodayJalaali,
} from "../utils/jalaaliUtils";

class GeneralStatistics extends Component {
  state = { intervalReports: null, isLoading: false };

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filterData !== this.props.filterData) {
      this.fetchData();
    }
  }

  convertToGregorian = (date) => {
    let date_values = date.split("/");
    let g = toGregorian(
      parseInt(date_values[0]),
      parseInt(date_values[1]),
      parseInt(date_values[2])
    );
    return `${g.gy}-${g.gm}-${g.gd}`;
  };

  fetchData = () => {
    this.setState({
      isLoading: true,
      intervalReports: null,
    });
    const { fromDate, toDate } = this.props.filterData;
    
    let local_from_date = fromDate.replaceAll("-", "/");
    let local_to_date = toDate.replaceAll("-", "/");;
    if (local_from_date == "" || local_to_date == "") {
      local_from_date = getTodayJalaali();
      local_to_date = getTodayJalaali();
    }

    this.props
      .getIntervalReports(
        this.convertToGregorian(local_from_date),
        this.convertToGregorian(local_to_date),
        this.props.filterData.selectedPaymentType,
        this.props.filterData.selectedBillStatus,
        1,
      )
      .then(() => {
        this.setState({
          isLoading: false,
          intervalReports: this.props.intervalReports
        });
      });
  };

  render() {
    const { intervalReports } = this.state;

    return (
      <React.Fragment>
        {this.state.isLoading && !intervalReports && <LoadingBar />}
        {!this.state.isLoading && intervalReports && Object.keys(intervalReports).length === 0 && (
          <NotFound />
        )}
        {!this.state.isLoading && intervalReports && Object.keys(intervalReports).length > 0 && (
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell className="table-border-left">
                  مجموع سود
                </Table.HeaderCell>
                <Table.HeaderCell>تخفیف</Table.HeaderCell>
                <Table.HeaderCell>مبلغ</Table.HeaderCell>
                <Table.HeaderCell>مبلغ نهایی</Table.HeaderCell>
                <Table.HeaderCell>مجموع اقلام</Table.HeaderCell>
                <Table.HeaderCell>مجموع فاکتورها</Table.HeaderCell>
                <Table.HeaderCell>مجموع چک های پرداخت شده</Table.HeaderCell>
                <Table.HeaderCell>مجموع پرداخت های نقدی</Table.HeaderCell>
                <Table.HeaderCell>مجموع پرداخت های کارتی</Table.HeaderCell>
                <Table.HeaderCell>مجموع پرداخت ها</Table.HeaderCell>
                <Table.HeaderCell>مجموع پرداخت های باقی مانده</Table.HeaderCell>
                <Table.HeaderCell>فاکتورهای پرداخت نشده</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell
                  className="table-border-left"
                  style={{ fontFamily: "arial" }}
                >
                  {digitToComma(this.state.intervalReports.total_profit)}
                </Table.Cell>
                <Table.Cell style={{ fontFamily: "arial" }}>
                  {digitToComma(this.state.intervalReports.total_discount)}
                </Table.Cell>
                <Table.Cell style={{ fontFamily: "arial" }}>
                  {digitToComma(this.state.intervalReports.total_price)}
                </Table.Cell>
                <Table.Cell style={{ fontFamily: "arial" }}>
                  {digitToComma(this.state.intervalReports.total_final_price)}
                </Table.Cell>
                <Table.Cell style={{ fontFamily: "arial" }}>
                  {digitToComma(this.state.intervalReports.total_items)}
                </Table.Cell>
                <Table.Cell style={{ fontFamily: "arial" }}>
                  {digitToComma(this.state.intervalReports.total_bills)}
                </Table.Cell>
                <Table.Cell style={{ fontFamily: "arial" }}>
                  {digitToComma(this.state.intervalReports.total_cheque_paid)}
                </Table.Cell>
                <Table.Cell style={{ fontFamily: "arial" }}>
                  {digitToComma(this.state.intervalReports.total_cash_paid)}
                </Table.Cell>
                <Table.Cell style={{ fontFamily: "arial" }}>
                  {digitToComma(this.state.intervalReports.total_card_paid)}
                </Table.Cell>
                <Table.Cell style={{ fontFamily: "arial" }}>
                  {digitToComma(this.state.intervalReports.total_paid)}
                </Table.Cell>
                <Table.Cell style={{ fontFamily: "arial" }}>
                  {digitToComma(
                    this.state.intervalReports.total_reminded_payments
                  )}
                </Table.Cell>
                <Table.Cell style={{ fontFamily: "arial" }}>
                  {digitToComma(
                    this.state.intervalReports.bills_with_reminded_status
                  )}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  intervalReports: state.reports.intervalReports,
});

export default connect(mapStateToProps, { getIntervalReports })(
  GeneralStatistics
);
